import { forwardRef, useMemo } from "react";
import { GroupBase, SelectComponentsConfig, SelectInstance } from "react-select";
import { AsyncPaginate, AsyncPaginateProps, wrapMenuList } from "react-select-async-paginate";
import { RefType } from "../../../../types";
import { genericMemo } from "../../../../utils";
import { Select, SelectProps } from "../Select";
import { MenuList } from "../Select/components";

export type AsyncSelectProps<
  Option = unknown,
  IsMulti extends boolean = boolean,
  Additional = {},
  Group extends GroupBase<Option> = GroupBase<Option>,
  R extends SelectInstance<Option, IsMulti, Group> = SelectInstance<Option, IsMulti, Group>
> = SelectProps<Option, IsMulti, Group, AsyncPaginateProps<Option, Group, Additional, IsMulti>, R>


const AsyncSelectComponent = <
  Option = unknown,
  IsMulti extends boolean = boolean,
  Additional = {},
  Group extends GroupBase<Option> = GroupBase<Option>,
  R extends SelectInstance<Option, IsMulti, Group> = SelectInstance<Option, IsMulti, Group>
>(props: AsyncSelectProps<Option, IsMulti, Additional, Group, R>) => <></>;
export type AsyncSelectComponentType = typeof AsyncSelectComponent;


export const AsyncSelect = genericMemo(forwardRef(<
  Option = unknown,
  IsMulti extends boolean = boolean,
  Additional = {},
  Group extends GroupBase<Option> = GroupBase<Option>,
  R extends SelectInstance<Option, IsMulti, Group> = SelectInstance<Option, IsMulti, Group>
>(
  props: AsyncSelectProps<Option, IsMulti, Additional, Group, R>,
  ref: RefType<R>,
) => {
  const selectComponents: SelectComponentsConfig<Option, IsMulti, Group> = useMemo(() => ({
    MenuList: wrapMenuList(MenuList),
    ...props.components,
  }), [ props.components ]);

  return (
    <Select<Option, IsMulti, Group, AsyncPaginateProps<Option, Group, Additional, IsMulti>, R>
      selectComponent={AsyncPaginate}
      {...props}
      components={selectComponents}
      selectRef={ref}
    />
  );
}) as AsyncSelectComponentType);



